import React from 'react';
import NonAccommodationRate from './non-accom-rates-table/non-accommodation_rate_table';
import AccommoRatesTable from './accommodation-rates-tables/accommodation_rate_table';
import {
  standardAccomDescr,
  standardNonAccomDescrs,
  multiDayTourDescrs,
} from '../../../../utils/contracting-preset-names-codes';

const RateTableTemplateContainer = props => {
  const {
    productType,
    rateSet,
    updateTableCell,
    showHeader,
    withEditableCell,
    forOffer,
    supplierEditable,
    onEdit,
    contractState,
    classes,
    addRateDetails,
    deleteFromProduct,
  } = props;
  const RateTemplate = productType === 'Non-Accommodation' ? NonAccommodationRate : AccommoRatesTable;
  const isApartmentRate = rateSet.rates.some(r => r.description.indexOf('Guest') > -1);
  const isPriceBreak = rateSet.nonStandardTemplateType === 'priceBreak';
  const isprivateTransfer = rateSet.nonStandardTemplateType === 'privateTransfer';
  const missingPresetDescrs = (() => {
    if (isPriceBreak || isprivateTransfer || isApartmentRate) return [];
    if (productType === 'Accommodation') {
      return standardAccomDescr.filter(d => rateSet.rates.every(r => r.description !== d));
    }
    if (rateSet.nonStandardTemplateType === 'multiDayTour') {
      return multiDayTourDescrs.filter(d => rateSet.rates.every(r => r.description !== d));
    }
    return standardNonAccomDescrs.filter(d => rateSet.rates.every(r => r.description !== d));
  })();
  return (
    <div>
        <RateTemplate
          showHeader={showHeader}
          rateSet={rateSet}
          withEditableCell={withEditableCell}
          updateTableCell={updateTableCell}
          forOffer={forOffer}
          supplierEditable={supplierEditable}
          onEdit={onEdit}
          contractState={contractState}
          classes={classes}
          deleteFromProduct={deleteFromProduct}
        />
        {
          Boolean(withEditableCell && (missingPresetDescrs.length || isApartmentRate || isPriceBreak || isprivateTransfer) && addRateDetails) && (
            <div
              style={{ marginTop: '8px', color: '#00bcd4', cursor: 'pointer' }}
              onClick={() => {
                if (missingPresetDescrs.length) {
                  addRateDetails([
                    ...rateSet.rates,
                    ...missingPresetDescrs.map(d => ({
                      description: d,
                      nettRate: 0,
                      retailRate: 0,
                      notApplicable: true,
                    }))]);
                } else {
                  addRateDetails([
                    ...rateSet.rates, {
                      description: '',
                      nettRate: 0,
                      retailRate: 0,
                      notApplicable: true,
                    }]);
                }
              }}
            >
              {missingPresetDescrs.length ? '+ add missing rate detail(s)' : '+ Add another rate detail'}
            </div>
          )
        }
      </div>
  );
};

export default RateTableTemplateContainer;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-tables/rate-table-template-container.jsx